<nz-layout>
  <nz-content class="centered">
    <div class="centered-box-vertical">
      <img *ngIf="!currentUser" class="logo" src="assets/img/teamsystem.png" />
      <h1
      i18n="Auth.CodeLost.Title|title for recovery emergency code@@Auth.CodeLost.Title">
      Recupero codice di emergenza
    </h1>
      <span
      i18n="Auth.CodeLost.Subtitle|subtitle for recovery emergency code@@Auth.CodeLost.Subtitle">
      Invia i dati richiesti per recuperare il codice di emergenza.
    </span>

      <nz-spin i18n-nzTip="Auth.Generic.SpinnerText|text in spinner@@Auth.Generic.SpinnerText"
      nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
      <form nz-form [formGroup]="codeLostForm" class="custom-form" (ngSubmit)="submitForm()">
        <nz-form-item class="login">
          <div nz-row>
            <div nz-col nzSpan="24">
              <nz-form-control
              [nzErrorTip]="getValidationErrorMessage(codeLostForm.controls.username.errors)">
                <nz-input-group nzPrefixIcon="user" class="login">
                  <input type="text" nz-input formControlName="username"
                  i18n-placeholder="Auth.Generic.PlaceholderUsername|placeholder for username in form@@Auth.Generic.PlaceholderUsername"
                  placeholder="Username" />
                </nz-input-group>
              </nz-form-control>
            </div>
          </div>
        </nz-form-item>
        <nz-form-item class="login">
          <div nz-row>
            <div nz-col nzSpan="24">
              <nz-form-control
              [nzErrorTip]="getValidationErrorMessage(codeLostForm.controls.cfOPIva.errors)">
                <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="passwordTemplate">
                  <input [type]="passwordVisible ? 'text' : 'cfOPIva'" nz-input formControlName="cfOPIva"
                  i18n-placeholder="Auth.Generic.PlaceholderCfOOPiva|placeholder for cfOPIva in form@@Auth.Generic.PlaceholderCfOOPiva"
                  placeholder="Codice fiscale o P.iva" />
                </nz-input-group>
                <ng-template #passwordTemplate>
                  <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                    (click)="passwordVisible = !passwordVisible"></i>
                </ng-template>
              </nz-form-control>
            </div>
          </div>
        </nz-form-item>

        <div nz-row nzAlign="middle" style="margin-bottom: 1rem;">
          <div nz-col [nzSpan]="16">
            <a class="custom-form-forgot" [routerLink]="getAuthLink()">
              <i nz-icon nzType="arrow-left" nzTheme="outline" style="margin-right: 0.5rem;"></i>
              <ng-container
              i18n="Auth.Generic.BackToSignInPage|label for go back to sign in page@@Auth.Generic.BackToSignInPage">
              {{returnMsg}}
            </ng-container>
              </a>
          </div>
          <div nz-col [nzSpan]="8">
            <button class="submit" nz-button nzType="primary"
            i18n="Generic.Send|label for send button@@Generic.Send" [disabled]="!codeLostForm.valid">INVIA</button>
          </div>
        </div>
      </form>
      </nz-spin>

    </div>
  </nz-content>
</nz-layout>
